module.exports = __webpack_public_path__ + "media/pdfs/key_fob_terms-b141a0b5030d71e89927cb5955549a06.pdf";